type LogArguments = ReadonlyArray<unknown>;

const log = (method: 'error' | 'warn' | 'info' | 'debug', args: LogArguments) => {
  // eslint-disable-next-line no-console
  console[method](...args);
};

export const logError = (...args: LogArguments): void => {
  log('error', args);
};

export const logWarn = (...args: LogArguments): void => {
  log('warn', args);
};

export const logInfo = (...args: LogArguments): void => {
  log('info', args);
};

export const logDebug = (...args: LogArguments): void => {
  log('debug', args);
};
